import { RfhTypography, Button } from '@rfh/ui'
import { MouseEvent as ReactMouseEvent, FC } from 'react'
import { useTranslation } from 'react-i18next'

const ReloadButton: FC<{
  message: string
  handleRefetchClick: (event: ReactMouseEvent<HTMLButtonElement>) => void
}> = ({ message, handleRefetchClick }) => {
  const { t } = useTranslation()
  return (
    <>
      <RfhTypography variant={'body-copy'}>{message}</RfhTypography>
      <Button
        variant={'text--link-icon'}
        onClick={(event): void => handleRefetchClick(event)}
      >
        {t('general:errors.reload')}
      </Button>
    </>
  )
}

export default ReloadButton
